export const AGENT_SKILLS_PANEL_ID = "agent-skills";
